module.exports = __webpack_public_path__ + "26325f03d9bd5df2aeeeb1a562f6c87b.png";